import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { YesNo } from 'interfaces';

export type Frequency = {
  frequency_id?: number; // 프리퀀시 idx
  frequency_name?: string; // 프리퀀시 이름
  frequency_start_date?: number; // 시작일
  frequency_end_date?: number; // 종료일
  frequency_content?: string; // 프리퀀시 내용
  is_show: (typeof YesNo)[keyof typeof YesNo]; // 노출여부
  is_stamp_convert?: (typeof YesNo)[keyof typeof YesNo]; // 기본 스탬프 전환 여부
  goal_num?: number; // 목표 갯수
  minimum_num?: number; // 프리퀀시 최소 갯수
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Frequency
   * --
   */
  getFrequencies: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_FREQUENCY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Frequency
   * --
   */
  getFrequency: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_FREQUENCY, {
        frequency_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Frequency
   * --
   */
  createFrequency: async (body: Frequency) => {
    try {
      const res = await $http.post(APIConstant.CREATE_FREQUENCY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Frequency
   * --
   */
  updateFrequency: async (body: Frequency) => {
    try {
      const { frequency_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_FREQUENCY, {
        frequency_id: frequency_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Frequency
   * --
   */
  deleteFrequency: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_FREQUENCY, {
        frequency_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
